import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
// import data from "./data";
import { useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import { Box, Button, IconButton, Tooltip, Paper, Typography, CircularProgress, useTheme } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
// import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify"
import { utils, writeFile } from "xlsx-js-style";
import * as XLSX from "xlsx-js-style";
import { AgGridReact } from "ag-grid-react";




const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const mapAoResponseToTable = (list = []) => {
  const total = list.reduce((sum, r) => sum + Number(r.totalCount || 0), 0);

  const rows = list.map((r) => ({
    reason: r.id,
    total: r.totalCount,
    percentage: total
      ? `${((r.totalCount / total) * 100).toFixed(2)}%`
      : "0.00%",
  }));

  const pinnedBottomRow = [
    {
      reason: "Total",
      total: total,
      percentage: "",
    },
  ];

  return {
    rows,
    pinnedBottomRow,
  };
};
const AO_REASON_ORDER = [
  { id: "POS Material", label: "POS Material" },
  { id: "Additional Requirement", label: "Additional Requirement from Client" },
  { id: "User/Installation Damage", label: "User / Installation Damage" },
  { id: "Missing Element1", label: "Missing Element 1" },
  { id: "Missing Element2", label: "Missing Element 2" },
  { id: "Transportation Damage", label: "Transportation Damage" },
  { id: "Wrong Delivery", label: "Wrong Delivery" },
  { id: "Product/Production Defect", label: "Product/ Production Defect" },
  { id: "Others", label: "Others" },
];
const mapCustomerAoTable = (aoResults = []) => {
  const map = {};
  aoResults.forEach(r => {
    map[r.id] = Number(r.totalCount || 0);
  });

  const rows =AO_REASON_ORDER.map(r => ({
    reason: r.label,
    total: map[r.id] || 0,
  }));

  const grandTotal = rows.reduce((s, r) => s + r.total, 0);

  return {
    rows: rows.map(r => ({
      ...r,
      percentage: grandTotal
        ? `${((r.total / grandTotal) * 100).toFixed(2)}%`
        : "0.00%",
    })),
    total: grandTotal,
  };
};
const mergeVendorTables = (vendorTables, vendorNames) => {
  const reasonMap = {};

  vendorNames.forEach((vendor) => {
    const rows = vendorTables[vendor]?.rows || [];

    rows.forEach((row) => {
      if (!reasonMap[row.reason]) {
        reasonMap[row.reason] = 0;
      }
      reasonMap[row.reason] += Number(row.total || 0);
    });
  });

  const mergedList = Object.keys(reasonMap).map((reason) => ({
    id: reason,
    totalCount: reasonMap[reason],
  }));

  return mapAoResponseToTable(mergedList);
};
const MiniTable = ({ title, data }) => {
  const columnDefs = [
    { headerName: "Reason", field: "reason", flex: 2, minWidth: 160, wrapText: true, autoHeight: true },
    {
      headerName: "Total",
      field: "total",
      width: 90,
      minWidth: 90,
      cellStyle: (params) => {
        if (params.node.rowPinned === "bottom") {
          return { color: "#d32f2f", fontWeight: "bold" };
        }
        return null;
      },
    },
    { headerName: "Percentage", field: "percentage", width: 110, minWidth: 100 },
  ];

  return (
    <Paper elevation={3} className="p-8">
      <h3 className="font-bold mb-4">{title}</h3>

      <div style={{ width: "100%", overflowX: "auto" }}>
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 350, minWidth: 360, width: "100%" }}
        >
          <AgGridReact
            rowData={data.rows}
            pinnedBottomRowData={data.pinnedBottomRow}
            columnDefs={columnDefs}
            getRowStyle={(params) => {
              if (params.node.rowPinned === "bottom") {
                return { fontWeight: "bold", color: "#d32f2f" };
              }
              return null;
            }}
            defaultColDef={{
              sortable: false,
              filter: false,
              resizable: false,
            }}
            domLayout="autoHeight"
            headerHeight={32}
            rowHeight={28}
          />
        </div>
      </div>
    </Paper>
  );
};
const initialValues = {
  customerId: "ALL",
};
 
 const getTotal = (rows) =>
  rows.reduce((sum, r) => sum + Number(r.total || 0), 0);

const autoFitColumns = (sheet, data) => {
  const colWidths = [];

  data.forEach((row) => {
    row.forEach((cell, idx) => {
      const len = cell ? cell.toString().length : 10;
      colWidths[idx] = Math.max(colWidths[idx] || 10, len + 2);
    });
  });

  sheet["!cols"] = colWidths.map((w) => ({ wch: w }));
};

 const styleTotalRow = (sheet, rowIndex) => {
  const range = XLSX.utils.decode_range(sheet["!ref"]);

  for (let c = range.s.c; c <= range.e.c; c++) {
    const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c });
    if (!sheet[cellAddress]) continue;

    sheet[cellAddress].s = {
      font: {
        bold: true,
        color: { rgb: "D32F2F" }, // red
      },
    };
  }
};

const AoReports = (props) => {
  
  const [filter, setFilter] = useState(initialValues);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerData,setCustomerData]=useState([]);
  const theme=useTheme();
 const defaultFromDate = moment()
  .subtract(1, "month")
  .startOf("month")
  .toDate();

const defaultToDate = moment()
  .subtract(1, "month")
  .endOf("month")
  .toDate();

  const [createdDateFrom, setCreatedDateFrom] = useState(defaultFromDate);
  const [createdDateTo, setCreatedDateTo] = useState(defaultToDate);

  const [summaryTable, setSummaryTable] = useState({
    rows: [],
    pinnedBottomRow: [],
  });
  const [combinedSummary, setCombinedSummary] = useState({
    rows: [],
    pinnedBottomRow: [],
  });
  const [vendorTables, setVendorTables] = useState({});
  const [loading, setLoading] = useState(false);
  const [custName,setCustName] = useState();
  const token =
      localStorage &&
      localStorage.getItem("token") &&
      jwtDecode(localStorage.getItem("token"));
  useEffect(() => {
    if(customerOptions && filter.customerId)
    {
      const customer=customerOptions?.find((r)=>r.value===filter?.customerId)
      setCustName(customer?.label)
    }
  }, [filter.customerId])
  

const buildPayload = (
  fromDate = createdDateFrom,
  toDate = createdDateTo,
  customerId = filter.customerId
) => {
  const payload = {
    startDate: moment(fromDate).format("YYYY-MM-DD"),
    endDate: moment(toDate).format("YYYY-MM-DD"),
  };

  if (customerId && customerId !== "ALL") {
    payload.customerNum = customerId;
  }

  return payload;
};
const getCustomer = async () => {
    try {
      const list = await OAuthService.getList(
        companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`
      );
      let companies = list.data?._embedded?.companies;
      companies = companies.map((company) => {
        return {
          value: company.id,
          label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
        };
      });
      companies = [{ value: "ALL", label: "ALL" }, ...companies];
      setCustomerOptions(companies);
    } catch (error) {
      toast.error(error.message)
    }
  };
  const handleSelectChange = (data, key) => {
  setFilter({
    ...filter,
    [key]: data ? data.value : "ALL",
  });
};

  const handleSearch = async (override={}) => {
     const {
    fromDate = createdDateFrom,
    toDate = createdDateTo,
    customerId = filter.customerId,
  } = override;
  setLoading(true)
    try {
       const payload = buildPayload(fromDate, toDate, customerId);

      const summaryRes = await OAuthService.addData(
        `${baseUrl}/api/part-order-analysis-report`,
        payload
      );

      setSummaryTable(mapAoResponseToTable(summaryRes?.data || []));

      const vendorRes = await OAuthService.addData(
        `${baseUrl}/api/part-order-analysis-report-all-vendors`,
        payload
      );

      const vendors = vendorRes?.data || {};
      const mappedVendors = {};

      vendors.forEach((vendor) => {
        mappedVendors[vendor.vendorName] = mapAoResponseToTable(
          vendor.aoResults || []
        );
      });

      setVendorTables(mappedVendors);
      const combined = mergeVendorTables(mappedVendors, [
        "NOLTE KUECHEN",
        "NOLTE ECO",
        "NOLTE NEO",
        "NOLTE SPA",
      ]);

      setCombinedSummary(combined);
      setLoading(false)
    } catch (error) {
      
       toast.error(error.message)
      console.error("AO Analysis Error", error);

        setLoading(false)
    }
  };
const formatHeadingDate = (date) =>
  moment(date).format("DD.MM.YYYY");

const selectedCustomerLabel = useMemo(() => {
  if (!filter.customerId || filter.customerId === "ALL") return null;

  const found = customerOptions?.find(
    (opt) => opt.value === filter.customerId
  );

  return found?.label;
}, [filter.customerId, customerOptions]);

const analysisHeading = useMemo(() => {
  const from = formatHeadingDate(createdDateFrom);
  const to = formatHeadingDate(createdDateTo);

  if (!filter.customerId || filter.customerId === "ALL") {
    return {
      title: `PART ORDER_ANALYSIS (From ${from} to ${to}) - All Partners-Summary`,
    };
  }

  return {
    title: `PART ORDER_ANALYSIS (From ${from} to ${to}) - Partner - ${selectedCustomerLabel} `,
  };
}, [createdDateFrom, createdDateTo, filter.customerId, selectedCustomerLabel]);
  useEffect(() => {
     getCustomer();
   
  }, []);
  const getCustomerAnalysis = useCallback(async () => {

  const payload = {
    startDate: moment(createdDateFrom).format("YYYY-MM-DD"),
    endDate: moment(createdDateTo).format("YYYY-MM-DD"),
  };

  try {
    const summaryRes = await OAuthService.addData(
      `${baseUrl}api/part-order-analysis-all-customers`,
      payload
    );
    setCustomerData(summaryRes?.data);
  } catch (error) {
    toast.error(error.message);
  }
}, [createdDateFrom, createdDateTo]);
 
useEffect(() => {
  if (!createdDateFrom || !createdDateTo) return;

  const loadData = async () => {
     await Promise.all([
    getCustomerAnalysis(),
    handleSearch()
  ]);
  };

  loadData();
}, [createdDateFrom, createdDateTo, filter.customerId]);
  const getRows = (tableData) => {
  if (!tableData) return [];

  if (Array.isArray(tableData)) return tableData;

  if (Array.isArray(tableData.rows)) return tableData.rows;

  return [];
}; 

const getAutoWidths = (sheetRows) => {
  const colWidths = [];
  sheetRows.forEach((row) => {
    row.forEach((cell, i) => {
      const val = typeof cell === "object" ? cell?.v || "" : cell;
      colWidths[i] = Math.max(colWidths[i] || 10, val.toString().length + 2);
    });
  });
  return colWidths.map((w) => ({ wch: w }));
};

/* ---------- BORDERS ---------- */
const THICK = { style: "medium", color: { rgb: "000000" } };
const THIN = { style: "thin", color: { rgb: "000000" } };

const getTableBorder = (r, c, sr, er, sc, ec) => ({
  top: r === sr ? THICK : THIN,
  bottom: r === er ? THICK : THIN,
  left: c === sc ? THICK : THIN,
  right: c === ec ? THICK : THIN,
});
const buildWorkbook = () => {
  const wb = utils.book_new();
  const wsData = [];
  const merges = [];
  let rowCursor = 0;

  const THICK = { style: "medium", color: { rgb: "000000" } };
  const THIN = { style: "thin", color: { rgb: "000000" } };

  const getTableBorder = (r, c, sr, er, sc, ec) => ({
    top: r === sr ? THICK : THIN,
    bottom: r === er ? THICK : THIN,
    left: c === sc ? THICK : THIN,
    right: THICK, 
  });

  const getAutoWidths = (sheetRows) => {
    const colWidths = [];
    sheetRows.forEach((row) => {
      row.forEach((cell, i) => {
        const val = typeof cell === "object" ? cell?.v || "" : cell;
        colWidths[i] = Math.max(colWidths[i] || 10, val.toString().length + 2);
      });
    });
    return colWidths.map((w) => ({ wch: w }));
  };

  const addSection = (title, tableData, options = {}) => {
    const { headingColor = "FF0000" } = options;
    const rows = getRows(tableData) || [];
    const total = getTotal(rows) || 0;

    const sectionStart = wsData.length;

    wsData.push([
      "",
      {
        v: title,
        s: {
          font: { bold: true, underline: true, sz: 18, color: { rgb: headingColor } },
          alignment: { horizontal: "center", vertical: "center", wrapText: true },
        },
      },
    ]);
    wsData.push([""]);
    merges.push({ s: { r: sectionStart, c: 1 }, e: { r: sectionStart + 1, c: 3 } });
    wsData.push([]);
    rowCursor += 3;

    const tableStartRow = wsData.length;

    wsData.push([
      "",
      { v: "Reason", s: { font: { bold: true }, fill: { fgColor: { rgb: "FFFF00" } } } },
      { v: "Total", s: { font: { bold: true }, alignment: { horizontal: "right" }, fill: { fgColor: { rgb: "FFFF00" } } } },
      { v: "Percentage", s: { font: { bold: true }, alignment: { horizontal: "right" }, fill: { fgColor: { rgb: "FFFF00" } } } },
    ]);

    rows.forEach((r) => {
      wsData.push([
        "",
        { v: r.reason },
        { v: r.total, s: { font: { bold: true }, alignment: { horizontal: "right" } } },
        { v: r.percentage, s: { alignment: { horizontal: "right" } } },
      ]);
    });

    // TOTAL ROW
    const totalRowIdx = wsData.length;
    wsData.push([
      "",
      { v: "TOTAL", s: { font: { bold: true }, alignment: { horizontal: "right" } } },
      {
        v: total,
        s: {
          font: { bold: true, color: { rgb: "FF0000" } }, 
          fill: { fgColor: { rgb: "FFFF00" } }, 
          alignment: { horizontal: "right" },
        },
      },
      { v: "", s: {} }, 
    ]);

    const tableEndRow = wsData.length - 1;

    for (let r = tableStartRow; r <= tableEndRow; r++) {
      for (let c = 1; c <= 3; c++) {
        const cell = wsData[r][c];
        if (cell && typeof cell === "object") {
          if (!cell.s) cell.s = {};
          cell.s.border = getTableBorder(r, c, tableStartRow, tableEndRow, 1, 3);
        }
      }
    }

    wsData.push([]);
    wsData.push([]);
    rowCursor += 2;
  };

  /* ---------- MAIN TITLE ---------- */
  const mainTitle = `PART ORDER ANALYSIS (From ${moment(createdDateFrom).format(
    "DD.MM.YYYY"
  )} to ${moment(createdDateTo).format("DD.MM.YYYY")}) - ${
    custName || "All Partners"
  }`;

  wsData.push([
    "",
    {
      v: mainTitle,
      s: {
        font: { bold: true, sz: 18 },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        fill: { fgColor: { rgb: "FFFF00" } },
        border: { top: THICK, bottom: THICK, left: THICK, right: THICK },
      },
    },
  ]);
  wsData.push([""]);
  merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 5 } });
  wsData.push([]);
  rowCursor = 3;

  addSection("SUMMARY", summaryTable, { headingColor: "000000" }); // Black

  const productWiseStart = wsData.length;
  wsData.push([
    "",
    {
      v: "PRODUCT WISE",
      s: {
        font: { bold: true, underline: true, sz: 18, color: { rgb: "000000" } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
      },
    },
  ]);
  wsData.push([""]);
  merges.push({ s: { r: productWiseStart, c: 1 }, e: { r: productWiseStart + 1, c: 5 } }); 
  wsData.push([]);
  rowCursor += 3;

  addSection("NK, NE, NS & NN (Combined)", combinedSummary, { headingColor: "FF0000" }); 
  Object.entries(vendorTables || {}).forEach(([vendor, table]) => {
    addSection(vendor, table, { headingColor: "FF0000" }); 
  });

  const ws = utils.aoa_to_sheet(wsData);
  ws["!merges"] = merges;
  ws["!cols"] = getAutoWidths(wsData);

  utils.book_append_sheet(wb, ws, "AO Analysis");
  return wb;
};
const titleText = `PART ORDER ANALYSIS (From ${moment(createdDateFrom).format(
  "DD.MM.YYYY"
)} to ${moment(createdDateTo).format("DD.MM.YYYY")}) - All Customers`;
const THIN_BORDER = {
  top: { style: "thin" },
  bottom: { style: "thin" },
  left: { style: "thin" },
  right: { style: "thin" },
};

const THICK_LEFT_BORDER = {
  top: { style: "thin" },
  bottom: { style: "thin" },
  left: { style: "thick" },
  right: { style: "thin" },
};
const addHorizontalTables = (
  wsData,
  startRow,
  nolteTable,
  expressTable,
  merges = []
) => {
  nolteTable = Array.isArray(nolteTable)
    ? nolteTable
    : nolteTable?.rows ?? [];

  expressTable = Array.isArray(expressTable)
    ? expressTable
    : expressTable?.rows ?? [];

  const LEFT_START_COL = 1;
  const RIGHT_START_COL = 5;
  const COL_COUNT = 3;
  wsData[startRow] ??= [];

  wsData[startRow][LEFT_START_COL] = {
    v: "NK + NS + NE + NN (Combined)",
    s: {
      font: { bold: true, sz: 13 ,color: { rgb: "FF0000" },},
      alignment: { horizontal: "center", vertical: "center" },
    },
  };

  wsData[startRow][RIGHT_START_COL] = {
    v: "EXPRESS KUECHEN",
    s: {
      font: { bold: true, sz: 13 ,color: { rgb: "FF0000" },},
      alignment: { horizontal: "center", vertical: "center" },
    },
  };

  merges.push({
    s: { r: startRow, c: LEFT_START_COL },
    e: { r: startRow, c: LEFT_START_COL + COL_COUNT - 1 },
  });

  merges.push({
    s: { r: startRow, c: RIGHT_START_COL },
    e: { r: startRow, c: RIGHT_START_COL + COL_COUNT - 1 },
  });

  startRow += 1;
  const headers = ["Reason", "Total", "Percentage"];

  const tableStartRow = startRow;

  /* ---------- HEADERS ---------- */
  headers.forEach((h, i) => {
    wsData[startRow] ??= [];

    wsData[startRow][LEFT_START_COL + i] = {
      v: h,
      s: {
        font: { bold: true },
        fill: { fgColor: { rgb: "FFFF00" } },
        alignment: { horizontal: "center" },
      },
    };

    wsData[startRow][RIGHT_START_COL + i] = {
      v: h,
      s: {
        font: { bold: true },
        fill: { fgColor: { rgb: "FFFF00" } },
        alignment: { horizontal: "center" },
      },
    };
  });

  let row = startRow + 1;
  const maxRows = Math.max(nolteTable.length, expressTable.length);

  /* ---------- DATA ROWS ---------- */
  for (let i = 0; i < maxRows; i++) {
    wsData[row] ??= [];

    const n = nolteTable[i];
    const e = expressTable[i];

    if (n) {
      wsData[row][LEFT_START_COL] = { v: n.reason };
      wsData[row][LEFT_START_COL + 1] = { v: n.total ,s: { font: { bold: true }, alignment: { horizontal: "right" } } };
      wsData[row][LEFT_START_COL + 2] = { v: n.percentage , s: { alignment: { horizontal: "right" } }};
    }

    if (e) {
      wsData[row][RIGHT_START_COL] = { v: e.reason };
      wsData[row][RIGHT_START_COL + 1] = { v: e.total ,s: { font: { bold: true }, alignment: { horizontal: "right" } } };
      wsData[row][RIGHT_START_COL + 2] = { v: e.percentage , s: { alignment: { horizontal: "right" } }};
    }

    row++;
  }

  /* ---------- TOTAL ROW ---------- */
  wsData[row] ??= [];

  wsData[row][LEFT_START_COL] = {
    v: "TOTAL",
    s: {
      font: { bold: true },
      alignment: { horizontal: "right" }
    },
  };

  wsData[row][LEFT_START_COL + 1] = {
    v: nolteTable.reduce((a, b) => a + (Number(b.total) || 0), 0),
    s: {
      font: { bold: true },
         fill: { fgColor: { rgb: "FFFF00" } },
       alignment: { horizontal: "right" },
    },
  };
  wsData[row][LEFT_START_COL + 2] = {
    v: "",
    s:{} ,
  };

  wsData[row][RIGHT_START_COL] = {
    v: "TOTAL",
    s: {
      font: { bold: true },
       alignment: { horizontal: "right" }
    },
  };

  wsData[row][RIGHT_START_COL + 1] = {
    v: expressTable.reduce((a, b) => a + (Number(b.total) || 0), 0),
    s: {
      font: { bold: true },
      fill: { fgColor: { rgb: "FFFF00" } },
       alignment: { horizontal: "right" },
    },
  };
  wsData[row][RIGHT_START_COL + 2] = {
    v: "",
    s: { },
  };

  row++;

  const tableEndRow = row - 1;

  /* ---------- APPLY BORDERS (OUTER THICK, INNER THIN) ---------- */
  const applyBorders = (rStart, rEnd, cStart, cEnd) => {
    for (let r = rStart; r <= rEnd; r++) {
      for (let c = cStart; c <= cEnd; c++) {
        const cell = wsData[r]?.[c];
        if (!cell) continue;

        cell.s ??= {};
        cell.s.border = {
          top: r === rStart ? THICK : THIN,
          bottom: r === rEnd ? THICK : THIN,
          left: c === cStart ? THICK : THIN,
          right: c === cEnd ? THICK : THIN,
        };
      }
    }
  };

  // Left (NOLTE)
  applyBorders(
    tableStartRow,
    tableEndRow,
    LEFT_START_COL,
    LEFT_START_COL + COL_COUNT - 1
  );

  // Right (EXPRESS)
  applyBorders(
    tableStartRow,
    tableEndRow,
    RIGHT_START_COL,
    RIGHT_START_COL + COL_COUNT - 1
  );

  return row;
};


const buildNolteCustomerTable = (vendorResults = []) => {
  const NOLTE = [
    "NOLTE KUECHEN",
    "NOLTE ECO",
    "NOLTE NEO",
    "NOLTE SPA",
  ];

  const reasonMap = {};

  vendorResults
    .filter(v => NOLTE.includes(v.vendorName))
    .forEach(v => {
      v.aoResults.forEach(r => {
        reasonMap[r.id] =
          (reasonMap[r.id] || 0) + Number(r.totalCount || 0);
      });
    });

  return mapCustomerAoTable(
    Object.keys(reasonMap).map(id => ({
      id,
      totalCount: reasonMap[id],
    }))
  );
};
const buildExpressCustomerTable = (vendorResults = []) => {
  const express = vendorResults.find(
    v => v.vendorName === "EXPRESS KUECHEN"
  );

  const aoResults = express?.aoResults || [];

  return mapCustomerAoTable(
    AO_REASON_ORDER.map(r => {
      const found = aoResults.find(x => x.id === r.id);
      return {
        id: r.id,
        totalCount: found?.totalCount || 0,
      };
    })
  );
};
const buildCustomerTables = (customer) => {
  
 

  const nolteTable = buildNolteCustomerTable(customer.vendorResults);
const expressTable = buildExpressCustomerTable(customer.vendorResults);

  return { nolteTable, expressTable };
};
const buildCustomerWorkbook = (customerData = []) => {
  const wb = utils.book_new();
  const wsData = [];
  const merges = [];
  let rowCursor = 0;

  /* ---------- TOP EMPTY ROWS ---------- */
  wsData[rowCursor++] = [];
  wsData[rowCursor++] = [];

  /* ---------- MAIN TITLE ---------- */
  wsData[rowCursor] = [];
  wsData[rowCursor][1] = {
    v: `PART ORDER ANALYSIS (From ${moment(createdDateFrom).format(
      "DD.MM.YYYY"
    )} to ${moment(createdDateTo).format("DD.MM.YYYY")}) - All Customers`,
    s: {
      font: { bold: true, sz: 18 ,wrapText:true},
      fill: { fgColor: { rgb: "FFFF00" } },
      alignment: { horizontal: "center", vertical: "center" },
    },
  };

  merges.push({
    s: { r: rowCursor, c: 1 },
    e: { r: rowCursor, c: 7 },
  });

  rowCursor += 2;

  /* ---------- CUSTOMER SECTIONS ---------- */
  customerData.forEach((customer) => {
    const headingRow = rowCursor;

    wsData[rowCursor] = [];
    wsData[rowCursor][1] = {
      v: `${customer.customerNum} - ${customer.shortKey}-${customer.country}`,
      s: {
        font: { bold: true, sz: 18,wrapText:true, underline: true,  },
        fill:{fgColor:{rgb:"CCFFCC"}},
        alignment: { horizontal: "center", vertical: "center" },
      },
    };

    merges.push({
      s: { r: headingRow, c: 1 },
      e: { r: headingRow, c: 7 },
    });

    rowCursor += 2;

    const nolteTable = buildNolteCustomerTable(customer.vendorResults);
    const expressTable = buildExpressCustomerTable(customer.vendorResults);

    rowCursor = addHorizontalTables(
      wsData,
      rowCursor,
      nolteTable,
      expressTable
    );

    wsData[rowCursor++] = [];
    wsData[rowCursor++] = [];
  });

  const ws = utils.aoa_to_sheet(wsData);
  ws["!merges"] = merges;
  ws["!cols"] = getAutoWidths(wsData);

  utils.book_append_sheet(wb, ws, "Customer AO Analysis");
  return wb;
};


const buildExcelBlob = (workbook) => {
  const buffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  return new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};
const handleDownloadExcelCustomer = () => {
  const workbook = buildCustomerWorkbook(customerData);

  const fileName = `PART_ORDER_ANALYSIS_CUSTOMER_${
    moment(createdDateFrom).format("DDMMYYYY")
  }_${moment(createdDateTo).format("DDMMYYYY")}.xlsx`;

  writeFile(workbook, fileName);
};
const handleSendExcel = async () => {
  try {
    setLoading(true);

    // 1. Build workbook (same function used for download)
    const workbook = buildWorkbook();

    // 2. Convert to Blob
    const excelBlob = buildExcelBlob(workbook);

    // 3. FormData
    const formData = new FormData();
    formData.append(
      "file",
      excelBlob,
      `PART_ORDER_ANALYSIS_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );

    // Optional metadata
    // formData.append("fromDate",createdDateFrom);
    // formData.append("toDate", createdDateTo);
    // formData.append(
    //   "customer",
    //   filter.customerId || "ALL"
    // );

    // 4. API call
    await OAuthService.addData(
      `${baseUrl}api/part-order-analysis-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Excel report sent successfully");
  } catch (error) {
    console.error("Send Excel Error", error);
    toast.error("Failed to send report");
  } finally {
    setLoading(false);
  }
};

const handleDownloadExcel = () => {
  const workbook = buildWorkbook();

  const fileName = `PART_ORDER_ANALYSIS_${
    filter?.customerId || "ALL"
  }_${moment(createdDateFrom).format("DDMMYYYY")}_${
    moment(createdDateTo).format("DDMMYYYY")
  }.xlsx`;

  writeFile(workbook, fileName); 
};
const handleClear = () => {
  const resetCustomer = "ALL";

  setFilter({ customerId: resetCustomer });
  setCreatedDateFrom(defaultFromDate);
  setCreatedDateTo(defaultToDate);

  handleSearch({
    fromDate: defaultFromDate,
    toDate: defaultToDate,
    customerId: resetCustomer,
  });
};

  return (
    <>
      <FormPageHeader
        componentName="AO Analysis"
        pageName="AO Analysis"
        currentPage="AO Analysis"
      >
        <Box className="flex pt-8 flex-col px-16 sm:px-24 mt-4" sx={{ pb: 1 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "2fr 1fr 1fr 2fr",
              },
              gap: 1.5,
              alignItems: "center",
            }}
          >
            <Select
              placeholder={"Customer"}
              name="customerId"
              value={
                filter.customerId &&
                customerOptions &&
                customerOptions.filter((obj) => filter.customerId === obj.value)
              }
              options={customerOptions}
              onChange={(e) => handleSelectChange(e, "customerId")}
              styles={customStyles()}
            />

            <CustomDatePicker
              label="Created From"
              format={"dd-MM-yyyy"}
              name={"createdDateFrom"}
              value={createdDateFrom || ""}
              maxDate={new Date()}
              handleChange={(date) => setCreatedDateFrom(date)}
              componentsProps={{ actionBar: { actions: ["clear"] } }}
            />

            <CustomDatePicker
              label="Created To"
              format={"dd-MM-yyyy"}
              name={"createdDateTo"}
              value={createdDateTo || ""}
              minDate={createdDateFrom}
              maxDate={new Date()}
              handleChange={(date) => setCreatedDateTo(date)}
              componentsProps={{ actionBar: { actions: ["clear"] } }}
            />

            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <Tooltip title="Download AO analysis Report">
                <Button
                  variant="contained"
                  size="small"
                  sx={{ minWidth: "auto" }}
                  style={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                  onClick={handleDownloadExcelCustomer}
                >
                  Customer Analysis
                </Button>
              </Tooltip>

              <Tooltip title="Download AO analysis Report">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ minWidth: "auto" }}
                  onClick={handleDownloadExcel}
                  style={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                >
                  Vendor Analysis
                </Button>
              </Tooltip>

              <Tooltip title="Clear">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ minWidth: "auto" }}
                  onClick={handleClear}
                  disabled={loading}
                  style={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                  }}
                >
                  <FuseSvgIcon size={18}>material-solid:clear_all</FuseSvgIcon>
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </FormPageHeader>

      {loading ? (
        <div className="flex justify-center py-24">
          <CircularProgress color="primary" size={18} />
        </div>
      ) : (
        <>
          <Box className="px-24 pt-12">
            <Typography variant="h6" fontWeight="bold">
              {analysisHeading.title}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              },
              gap: 2,
              p: { xs: 2, sm: 3 },
            }}
          >
            <MiniTable title="Summary" data={summaryTable} />
            <MiniTable
              title="NK + NE + NS + NN (Combined)"
              data={combinedSummary}
            />
            {Object.keys(vendorTables).map((vendor) => (
              <MiniTable
                key={vendor}
                title={vendor}
                data={vendorTables[vendor]}
              />
            ))}
          </Box>
        </>
      )}
    </>
  );
};

export default AoReports;
